<template>
  <video class="spotlight-video" autoplay loop muted playsinline>
    <source :src="file.url" :type="file.mime"/>
  </video>
</template>
<script>
export default {
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  mounted () {
    const promise = this.$el.play()

    // promise won’t be defined in browsers that don't support promisified play()
    if (promise === undefined) {
      console.warn('Promisified video play() not supported')
    } else {
      promise.catch((error) => {
        console.error('Error initiating video playback: ', error)
      })
    }
  }
}
</script>
<style lang="stylus">
.spotlight-video
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  top: 0;
  left: 0;
</style>
